import packageJson from "@/package.json";
import Link from "next/link";
import Image from "next/image";

export default function Footer( ) {
  const version = packageJson.version;
  const buildDate = packageJson.buildDate;

  return (
    <footer className="w-full bg-gradient-to-br from-gray-900 to-black text-white py-3">
      <div className="container mx-auto px-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          <div className="flex flex-col items-center sm:items-start">
            <div className="flex items-center mb-2">
              <Image
                src={`${process.env.basePath}/da4ndo.png`}
                alt="Da4ndo logó"
                width={35}
                height={35}
                className="rounded-full"
              />
              <span className="text-lg font-bold mx-2">&</span>
              <Image
                src={`${process.env.basePath}/BME.svg`}
                alt="BME logó"
                width={90}
                height={24}
                className="white-logo ml-2"
              />
            </div>
            <p className="text-[11px] text-gray-400 mt-1 text-center sm:text-left">
              Együtt innoválunk egy okosabb jövőért.
            </p>
          </div>

          <div className="text-center sm:text-left">
            <h2 className="text-base font-bold mb-2">Gyors Linkek</h2>
            <ul className="space-y-0.5 text-xs">
              <li>
                <Link
                  href="https://kozlekedes.bme.hu/"
                  className="hover:text-blue-300 transition-colors"
                >
                  BME Közlekedésmérnöki és Járműmérnöki Kar
                </Link>
              </li>
              <li>
                <Link
                  href="http://da4ndo.com"
                  className="hover:text-blue-300 transition-colors"
                >
                  Da4ndo - Szoftverfejlesztő és Tesztelő
                </Link>
              </li>
            </ul>
          </div>

          <div className="text-center sm:text-right mt-2 sm:mt-0">
            <h2 className="text-base font-bold mb-2">Kapcsolat</h2>

            <p className="text-[11px]">Támogatásért vagy kérdésekért:</p>
            <Link
              href="mailto:contact@da4ndo.com"
              className="text-blue-300 hover:text-blue-100 transition-colors text-xs"
            >
              contact@da4ndo.com
            </Link>
            <div className="flex flex-col items-center sm:items-end">
              <div className="text-center sm:text-right">
                <p className="mt-2 text-[11px]">
                  <span className="font-bold">Verzió:</span>{" "}
                  {version}
                  {(() => {
                    const buildDateObj = new Date(buildDate);
                    const currentDate = new Date();
                    const threeMonthsAgo = new Date(
                      currentDate.getFullYear(),
                      currentDate.getMonth(),
                      currentDate.getDate() - 14
                    );
                    return (
                      buildDateObj > threeMonthsAgo && (
                        <span className="ml-2 text-green-400 font-bold">
                          (új)
                        </span>
                      )
                    );
                  })()}
                </p>
                <p className="text-[11px]">
                  <span className="font-bold">Készült:</span>{" "}
                  {new Date(buildDate).toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-3 pt-2 border-t border-gray-700 text-center">
          <p className="text-[11px] text-gray-400">
            © {new Date().getFullYear()}{" "}
            <a href="https://kozlekedes.bme.hu" className="hover:underline">BME Közlekedésmérnöki és Járműmérnöki Kar</a> &{" "}
            <a href="https://da4ndo.com" className="hover:underline">Da4ndo</a>. Minden jog
            fenntartva.
          </p>
          <p className="text-[11px] text-gray-500 mt-1">
            <Link
              href="/privacy-policy"
              className="hover:text-blue-300 transition-colors"
            >
              Adatvédelmi Irányelvek
            </Link>
            {" | "}
            <Link
              href="/terms-of-service"
              className="hover:text-blue-300 transition-colors"
            >
              Szolgáltatási Feltételek
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
